// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as PnMCampaignApiModal$PorterinFeature from "../../api-model/PnMCampaignApiModal.mjs";

function getCtaProp(prop) {
  return {
          label: prop.label,
          href: Belt_Option.getWithDefault(prop.href, "")
        };
}

function getTestimonialProp(testimonial) {
  return {
          text: testimonial.text,
          sub_text: testimonial.sub_text
        };
}

function getCampaignSection(section) {
  var tmp;
  if (section.has_button) {
    var cta = section.cta;
    tmp = cta !== undefined ? getCtaProp(cta) : null;
  } else {
    tmp = null;
  }
  var tmp$1;
  if (section.has_video) {
    var video = section.campaign_video;
    tmp$1 = video !== undefined ? getCtaProp(video) : null;
  } else {
    tmp$1 = null;
  }
  return {
          has_button: section.has_button,
          has_testimonial: section.has_testimonial,
          has_video: section.has_video,
          campaign_image: {
            alt_text: section.campaign_image.alt_text,
            src_path: {
              data: {
                attributes: {
                  url: section.campaign_image.src_path.data.attributes.url
                }
              }
            }
          },
          cta: tmp,
          campaign_video: tmp$1,
          testimonial: section.has_testimonial ? Belt_Array.map(section.testimonial, getTestimonialProp) : []
        };
}

function getTermsAndConditions(terms) {
  return {
          text: terms.text,
          sub_text: terms.sub_text,
          link: terms.link
        };
}

function apiModelToState(model) {
  return {
          title: model.data.attributes.title,
          campaign_section: Belt_Array.map(model.data.attributes.campaign_section, getCampaignSection),
          terms_and_conditions: getTermsAndConditions(model.data.attributes.terms_and_conditions)
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(PnMCampaignApiModal$PorterinFeature.t_decode(json), "PnMCampaignEntityMapper.res"));
}

export {
  getCtaProp ,
  getTestimonialProp ,
  getCampaignSection ,
  getTermsAndConditions ,
  apiModelToState ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
